import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { formatFingerprintMetric } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-electrical-summary',
  templateUrl: './electrical-summary.component.html',
  styleUrls: ['../../summary-panels.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintElectricalSummaryComponent {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly formatValue = formatFingerprintMetric;
  readonly metrics = [
    { field: 'fPowerOnMean', label: 'ولتاژ روشن', decimals: 2, unit: 'V' },
    { field: 'fPowerOffMean', label: 'ولتاژ خاموش', decimals: 2, unit: 'V' },
    { field: 'fPowerOnStd', label: 'انحراف معیار ولتاژ', decimals: 3, unit: 'V' },
    { field: 'fPowerOnP95', label: 'صدک 95 ولتاژ', decimals: 2, unit: 'V' },
    { field: 'iValidPowerRecords', label: 'رکورد معتبر ولتاژ', decimals: 0, unit: '' },
  ] as const;
}
